import PropTypes from 'prop-types';
import Select from '../../../../juristec-ui/core/SelectNew';

const SelectInput = ({
  label, state, handle, options, isMultiple = false,
}) => (
  <>
    <h5 className={state.error ? 'field-error-label' : ''}>
      {label}
    </h5>
    <Select
      label=""
      options={options}
      value={isMultiple ? state.selected : state}
      onChange={handle}
      searchable
      atModal
      selectAll={isMultiple}
      multiple={isMultiple}
      stayOpen={isMultiple}
    />
    {state.errorMsg?.length > 0 && (
      <span className="field-error-msg">
        {state.errorMsg}
      </span>
    )}
  </>
);

SelectInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    selected: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  handle: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMultiple: PropTypes.bool,
};

export default SelectInput;
